/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button as ChakraButton,
  VStack,
} from "@chakra-ui/react";
import GuestInviteSample from "../EmailTemplates/GuestInviteSample";
// import WhatsAppMessaging from "../WhatsAppMessaging";
import { GuestAndIsChecked } from "../../../../types/guest";
import { MessagingStore } from "../types";

type InviteMethod = "email" | "whatsapp";

interface WeddingInviteWithWhatsAppProps {
  selectedGuests: GuestAndIsChecked[];
}

const WeddingInviteWithWhatsApp: React.FC<WeddingInviteWithWhatsAppProps> = ({
  selectedGuests,
}) => {
  const [selectedMethod, setSelectedMethod] = useState<InviteMethod>("email");

  // Store the selected method in MessagingStore so parent can hide email buttons
  useEffect(() => {
    MessagingStore.isWhatsAppMode = selectedMethod === "whatsapp";
  }, [selectedMethod]);

  return (
    <Flex
      flexDir={"column"}
      gap={"1rem"}
      w={"full"}
      h={"full"}
      justify={"flex-start"}
      align={"center"}
      pt={4}
    >
      {/* Toggle between Email and WhatsApp */}
      <Flex
        gap={2}
        bg="#F9F9F9"
        p={1}
        borderRadius="full"
        border="1px solid #E2E8F0"
      >
        <ChakraButton
          size="sm"
          borderRadius="full"
          onClick={() => setSelectedMethod("email")}
          bg={selectedMethod === "email" ? "#000" : "transparent"}
          color={selectedMethod === "email" ? "#fff" : "#000"}
          _hover={{
            bg: selectedMethod === "email" ? "#000" : "#E2E8F0",
          }}
          fontFamily="font4"
          textTransform="uppercase"
          fontSize="0.75rem"
          letterSpacing="0.5px"
          px={6}
        >
          Email
        </ChakraButton>
        <ChakraButton
          size="sm"
          borderRadius="full"
          onClick={() => setSelectedMethod("whatsapp")}
          bg={selectedMethod === "whatsapp" ? "#25D366" : "transparent"}
          color={selectedMethod === "whatsapp" ? "#fff" : "#000"}
          _hover={{
            bg: selectedMethod === "whatsapp" ? "#25D366" : "#E2E8F0",
          }}
          fontFamily="font4"
          textTransform="uppercase"
          fontSize="0.75rem"
          letterSpacing="0.5px"
          px={6}
        >
          WhatsApp
        </ChakraButton>
      </Flex>

      {/* Content based on selection */}
      {selectedMethod === "email" ? (
        <VStack spacing={4} w="full" align="center">
          <GuestInviteSample />
          <Text fontSize="sm" color="gray.600" textAlign="center" maxW="400px">
            Send wedding invitations via email to your guests
          </Text>
        </VStack>
      ) : (
        <VStack
          spacing={6}
          w="full"
          align="center"
          justify="center"
          minH="400px"
        >
          <Box
            bg="#F9F9F9"
            p={8}
            borderRadius="lg"
            border="1px solid #E2E8F0"
            textAlign="center"
            maxW="500px"
          >
            <Text
              fontSize="2xl"
              fontWeight="bold"
              color="#25D366"
              mb={3}
              fontFamily="font4"
            >
              Coming Soon
            </Text>
            <Text fontSize="md" color="gray.600" mb={2}>
              WhatsApp messaging feature is under development
            </Text>
            <Text fontSize="sm" color="gray.500">
              Send personalized wedding invitations directly to your guests via
              WhatsApp
            </Text>
          </Box>
        </VStack>
      )}
    </Flex>
  );
};

export default WeddingInviteWithWhatsApp;
